/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Scan_QrInputs */

const vi_nav_scan_qr = /** @type {(inputs: Nav_Scan_QrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quét QR`)
};

/**

* @param {Nav_Scan_QrInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const nav_scan_qr = /** @type {((inputs?: Nav_Scan_QrInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Scan_QrInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_nav_scan_qr(inputs)
});